import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  base: "/",
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          component: () =>
            import("@/view/pages/Dashboard")
        },
        {
          path: "/management",
          name: "management",
          component: () =>
            import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
          children: [
            {
              path: "/users",
              name: "management.users",
              component: () =>
                import("@/view/pages/management/users/UsersIndex.vue")
            },
            {
              path: "/users/:id/edit",
              name: "management.users.edit",
              component: () =>
                import("@/view/pages/management/users/UsersCreateEdit")
            },
            {
              path: "/users/create",
              name: "management.users.create",
              component: () =>
                import("@/view/pages/management/users/UsersCreateEdit")
            },
            {
              path: "/institutions",
              name: "management.institutions",
              component: () =>
                  import("@/view/pages/management/institutions/InstitutionsIndex.vue")
            },
            {
              path: "/institutions/:id/edit",
              name: "management.institutions.edit",
              component: () =>
                  import("@/view/pages/management/institutions/InstitutionsCreateEdit")
            },
            {
              path: "/institutions/create",
              name: "management.institutions.create",
              component: () =>
                  import("@/view/pages/management/institutions/InstitutionsCreateEdit")
            },
            {
              path: "/branches",
              name: "management.branches",
              component: () =>
                  import("@/view/pages/management/branches/BranchesIndex.vue")
            },
            {
              path: "/branches/:id/edit",
              name: "management.branches.edit",
              component: () =>
                  import("@/view/pages/management/branches/BranchesCreateEdit")
            },
            {
              path: "/branches/create",
              name: "management.branches.create",
              component: () =>
                  import("@/view/pages/management/branches/BranchesCreateEdit")
            },
            {
              path: "/team-types",
              name: "management.team_types",
              component: () =>
                  import("@/view/pages/management/teamTypes/TeamTypeIndex.vue")
            },
            {
              path: "/team-types/:id/edit",
              name: "management.team_types.edit",
              component: () =>
                  import("@/view/pages/management/teamTypes/TeamTypeCreateEdit")
            },
            {
              path: "/team-types/create",
              name: "management.team_types.create",
              component: () =>
                  import("@/view/pages/management/teamTypes/TeamTypeCreateEdit")
            },
            {
              path: "/regions",
              name: "management.regions",
              component: () =>
                  import("@/view/pages/management/regions/RegionsIndex.vue")
            },
            {
              path: "/regions/:id/edit",
              name: "management.regions.edit",
              component: () =>
                  import("@/view/pages/management/regions/RegionsCreateEdit")
            },
            {
              path: "/regions/create",
              name: "management.regions.create",
              component: () =>
                  import("@/view/pages/management/regions/RegionsCreateEdit")
            },
            {
              path: "/service-types",
              name: "management.service_types",
              component: () =>
                  import("@/view/pages/management/serviceTypes/ServiceTypeIndex.vue")
            },
            {
              path: "/service-types/:id/edit",
              name: "management.service_types.edit",
              component: () =>
                  import("@/view/pages/management/serviceTypes/ServiceTypeCreateEdit")
            },
            {
              path: "/service-types/create",
              name: "management.service_types.create",
              component: () =>
                  import("@/view/pages/management/serviceTypes/ServiceTypeCreateEdit")
            },
            {
              path: "/service-statuses",
              name: "management.service_statuses",
              component: () =>
                  import("@/view/pages/management/serviceStatuses/ServiceStatusIndex.vue")
            },
            {
              path: "/service-statuses/:id/edit",
              name: "management.service_statuses.edit",
              component: () =>
                  import("@/view/pages/management/serviceStatuses/ServiceStatusCreateEdit")
            },
            {
              path: "/service-statuses/create",
              name: "management.service_statuses.create",
              component: () =>
                  import("@/view/pages/management/serviceStatuses/ServiceStatusCreateEdit")
            },
            {
              path: "/services",
              name: "management.services",
              component: () =>
                  import("@/view/pages/management/services/ServiceIndex.vue")
            },
            {
              path: "/services/:id/edit",
              name: "management.services.edit",
              component: () =>
                  import("@/view/pages/management/services/ServiceCreateEdit")
            },
            {
              path: "/services/create",
              name: "management.services.create",
              component: () =>
                  import("@/view/pages/management/services/ServiceCreateEdit")
            },
            {
              path: "/roles",
              name: "management.roles.index",
              component: () => import("@/view/pages/management/roles/RolesIndex"),
            },
            {
              path: "/roles/:id/edit",
              name: "management.roles.edit",
              component: () => import("@/view/pages/management/roles/RolesCreateEdit"),
            },

            {
              path: "/roles/create",
              name: "management.roles.create",
              component: () => import("@/view/pages/management/roles/RolesCreateEdit"),
            },
            {
              path: "/materials",
              name: "store.materials",
              component: () =>
                  import("@/view/pages/management/materials/MaterialIndex.vue")
            },
            {
              path: "/materials/:id/edit",
              name: "store.materials.edit",
              component: () =>
                  import("@/view/pages/management/materials/MaterialCreateEdit")
            },
            {
              path: "/materials/create",
              name: "store.materials.create",
              component: () =>
                  import("@/view/pages/management/materials/MaterialCreateEdit")
            },
            {
              path: "/supplier-companies",
              name: "management.supplier_companies",
              component: () =>
                  import("@/view/pages/management/supplierCompanies/SupplierCompaniesIndex.vue")
            },
            {
              path: "/supplier-companies/:id/edit",
              name: "management.supplier_companies.edit",
              component: () =>
                  import("@/view/pages/management/supplierCompanies/SupplierCompaniesCreateEdit")
            },
            {
              path: "/supplier-companies/create",
              name: "management.supplier_companies.create",
              component: () =>
                  import("@/view/pages/management/supplierCompanies/SupplierCompaniesCreateEdit")
            },
            {
              path: "/brands",
              name: "management.brands",
              component: () =>
                  import("@/view/pages/management/brands/BrandsIndex.vue")
            },
            {
              path: "/brands/:id/edit",
              name: "management.brands.edit",
              component: () =>
                  import("@/view/pages/management/brands/BrandsCreateEdit")
            },
            {
              path: "/brands/create",
              name: "management.brands.create",
              component: () =>
                  import("@/view/pages/management/brands/BrandsCreateEdit")
            },
            {
              path: "/material-models",
              name: "management.material_models",
              component: () =>
                  import("@/view/pages/management/materialModels/MaterialModelsIndex")
            },
            {
              path: "/material-models/:id/edit",
              name: "management.material_models.edit",
              component: () =>
                  import("@/view/pages/management/materialModels/MaterialModelsCreateEdit")
            },
            {
              path: "/material-models/create",
              name: "management.material_models.create",
              component: () =>
                  import("@/view/pages/management/materialModels/MaterialModelsCreateEdit")
            },
            {
              path: "/waybills",
              name: "store.waybills",
              component: () =>
                  import("@/view/pages/management/waybills/WaybillIndex")
            },
            {
              path: "/waybills/:id/edit",
              name: "store.waybills.edit",
              component: () =>
                  import("@/view/pages/management/waybills/WaybillCreateEdit")
            },
            {
              path: "/waybills/create",
              name: "store.waybills.create",
              component: () =>
                  import("@/view/pages/management/waybills/WaybillCreateEdit")
            },
            {
              path: "/stocks",
              name: "store.stocks",
              component: () =>
                  import("@/view/pages/management/stocks/StockIndex.vue")
            },
            {
              path: "/stocks/:id/edit",
              name: "store.stocks.edit",
              component: () =>
                  import("@/view/pages/management/stocks/StockCreateEdit")
            },
            {
              path: "/stocks/create",
              name: "store.stocks.create",
              component: () =>
                  import("@/view/pages/management/stocks/StockCreateEdit")
            },
            {
              path: "/report-institutions",
              name: "reports.institutions",
              component: () =>
                  import("@/view/pages/report/InstitutionsReport.vue")
            },            {
              path: "/report-branches",
              name: "reports.branches",
              component: () =>
                  import("@/view/pages/report/BranchesReport.vue")
            },
          ]
        }
      ]
    },
    {
      path: "/custom-error",
      name: "error",
      component: () => import("@/view/pages/error/Error.vue"),
      children: [
        {
          path: "error-1",
          name: "error-1",
          component: () => import("@/view/pages/error/Error-1.vue")
        },
        {
          path: "error-2",
          name: "error-2",
          component: () => import("@/view/pages/error/Error-2.vue")
        },
        {
          path: "error-3",
          name: "error-3",
          component: () => import("@/view/pages/error/Error-3.vue")
        },
        {
          path: "error-4",
          name: "error-4",
          component: () => import("@/view/pages/error/Error-4.vue")
        },
        {
          path: "error-5",
          name: "error-5",
          component: () => import("@/view/pages/error/Error-5.vue")
        },
        {
          path: "error-6",
          name: "error-6",
          component: () => import("@/view/pages/error/Error-6.vue")
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/view/pages/auth/Login")
    },
    {
      path: "/forgot-password",
      name: "forgot_password",
      component: () => import("@/view/pages/auth/ForgotPassword")
    },
    {
      path: "/reset-password/:token",
      name: "reset_password",
      component: () => import("@/view/pages/auth/ResetPassword")
    },
    {
      // the 404 route, when none of the above matches
      path: "/403",
      name: "403",
      component: () => import("@/view/pages/error/403.vue")
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue")
    }
  ]
});
